"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_forms_1 = require("@hotelplan/components.common.forms");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const TravelDestinationInput_1 = __importDefault(require("./TravelDestinationInput"));
const TravelDestionation_utils_1 = require("./TravelDestionation.utils");
const SearchDestinationFakeInput = (0, styled_components_1.default)(components_common_inputs_1.FakeInput)(({ theme }) => theme.inputs.searchControlField);
const SearchDestinationInput = (0, styled_components_1.default)(TravelDestinationInput_1.default)(({ theme, customLabel }) => (Object.assign(Object.assign({}, theme.inputs.searchControlField), { '.autocomplete-dropdown': {
        top: Boolean(customLabel) ? '28px' : 0,
    } })));
const TravelDestinationField = props => {
    const [t] = (0, next_i18next_1.useTranslation)(['search', 'common']);
    const [value, onChange] = (0, components_common_forms_1.useField)('travelDestination');
    const { destinations: originalDestination } = value || { destinations: [] };
    const destinations = (originalDestination ||
        []);
    const onChangeDestinations = (nextDestinations) => {
        onChange(Object.assign(Object.assign({}, value), { destinations: nextDestinations }));
    };
    if (props.disabled) {
        return (react_1.default.createElement(SearchDestinationFakeInput, { icon: 'planet', placeholder: t('search:destination.placeholder'), value: (0, TravelDestionation_utils_1.getShortInformation)(t, destinations, props.limit), className: props.className }));
    }
    return (react_1.default.createElement(SearchDestinationInput, Object.assign({ label: t('search:destination.label'), placeholder: t('search:destination.placeholder'), value: destinations, onChange: onChangeDestinations, customLabel: props.customLabel, className: "travelDestinationInput" }, props), props.children));
};
exports.default = TravelDestinationField;
//# sourceMappingURL=TravelDestinationField.js.map